import React, { useEffect, useRef, useState } from "react";
import "../estimate/estimateWorkspace.css";

/**
 * Compact "⋯" menu shared by Estimate and Project workspaces.
 * Secondary actions stay off the primary row.
 */
export function WorkspaceOverflowMenu({ items, ariaLabel = "More actions" }) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;

    function handleOutside(event) {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    }
    function handleEscape(event) {
      if (event.key === "Escape") setOpen(false);
    }

    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open]);

  const visibleItems = (items || []).filter(Boolean);
  if (visibleItems.length === 0) return null;

  return (
    <div className="est-overflow-menu" ref={rootRef}>
      <button
        type="button"
        className="est-overflow-menu-trigger"
        aria-label={ariaLabel}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={(event) => {
          event.stopPropagation();
          setOpen((value) => !value);
        }}
      >
        ⋯
      </button>

      {open && (
        <div className="est-overflow-menu-panel" role="menu">
          {visibleItems.map((item) => (
            <button
              key={item.label}
              type="button"
              role="menuitem"
              className={
                "est-overflow-menu-item" +
                (item.destructive ? " est-overflow-menu-item--destructive" : "")
              }
              onClick={(event) => {
                event.stopPropagation();
                setOpen(false);
                item.onClick();
              }}
              disabled={item.disabled}
            >
              {item.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
